<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="Map"><span href="#/xhtml/contents#c_Map" title="Link target outside of Sample"><span class="epub-b">NEAR SIDE</span> <span class="epub-bi">of</span> <span class="epub-b">THE MOON</span></span></p>
<p class="img"><img alt="image" height="557" src="images/pgix.jpg" width="550"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fmtext2.vue?ad341322